<template>
  <div class="overlay" :style="openCarousel ? '' : { left: '100%' }">
    <div class="carousel-wrapper">
      <div
        ref="slideMobile"
        @touchstart.passive="touchStart"
        @touchend.passive="touchEnd"
        v-for="(item, index) in slides"
        :key="item?.movie_id"
        class="carousel-item"
        :class="index === 0 ? 'primary' : index === 1 ? 'secondary' : 'tret'"
      >
        <div class="description">
          <div class="title">{{ item?.title }}</div>
          <div class="genres">{{ item?.genres }}</div>
          <div class="country">{{ item?.country }}</div>
          <div class="rating">IMDb: {{ item?.rating }}</div>
          <div class="time">{{ item?.time }} минут</div>
        </div>
        <div class="image">
          <img class="slide-right" :src="item?.poster" />
        </div>
      </div>
    </div>
    <div class="paginate">
      <div>
        <span
          v-for="item in data"
          :key="item?.movie_id"
          @click="handleSlide(item?.movie_id)"
          :class="item?.movie_id === slides[0]?.movie_id ? 'active-slide' : ''"
        ></span>
      </div>
    </div>
    <div class="control-button">
      <button @click="openCarousel = !openCarousel" class="button-right">
        <i class="fas fa-chevron-right"></i>
      </button>
      <button @click="openCarousel = !openCarousel" class="button-left">
        <i class="fas fa-chevron-left"></i>
      </button>
    </div>
  </div>
</template>

<script>
import { useFormatter } from "@/utils/formatter";
import { useOrm } from "@/utils/orm";
import { computed, onMounted, onBeforeUnmount, ref, watch } from "vue";
import { useStore } from "vuex";

export default {
  setup() {
    const store = useStore();
    let openCarousel = ref(false);
    const slides = ref([]);

    const { moveArrayItemToNewIndex } = useFormatter();
    const { getByUnique } = useOrm();

    const handleSlide = (dir = "first") => {
      if (dir === "first") {
        slides.value = moveArrayItemToNewIndex(
          slides.value,
          0,
          slides.value.length - 1
        );
      } else if (dir === "last") {
        slides.value = moveArrayItemToNewIndex(
          slides.value,
          slides.value.length - 1,
          0
        );
      } else {
        const realIndex = getByUnique(dir, slides.value, "movie_id", true);
        slides.value.push(...slides.value.splice(0, realIndex));
      }
    };

    let mainInterval;
    onMounted(() => {
      mainInterval = setInterval(() => handleSlide("last"), 5000);
    });

    onBeforeUnmount(() => {
      if (mainInterval) clearInterval(mainInterval);
    });
    const checkWidth = () => {
      if (typeof window !== "undefined") {
        if (window.innerWidth >= 992) {
          openCarousel.value = true;
        }
        if (window.innerWidth < 992) {
          openCarousel.value = false;
        }
      }
    };
    var resizeTimeout;
    function resizeThrottler() {
      if (!resizeTimeout) {
        resizeTimeout = setTimeout(function() {
          resizeTimeout = null;
          checkWidth();

          // The checkWidth will execute at a rate of 15fps
        }, 66);
      }
    }

    onMounted(() => {
      window.addEventListener("resize", resizeThrottler, false);
      resizeThrottler();
    });

    //Swipe touch screen
    let slideMobile = ref(null);

    let touchstartX = 0;
    let touchstartY = 0;
    let touchendX = 0;
    let touchendY = 0;

    const touchStart = event => {
      touchstartX = event.changedTouches[0].screenX;
      touchstartY = event.changedTouches[0].screenY;
    };

    const touchEnd = event => {
      touchendX = event.changedTouches[0].screenX;
      touchendY = event.changedTouches[0].screenY;
      handleGesture();
    };

    const handleGesture = () => {
      if (touchendX < touchstartX) {
        // console.log("Swiped left");
        handleSlide("first");
      }

      if (touchendX > touchstartX) {
        // console.log("Swiped right");
        handleSlide("last");
      }

      if (touchendY < touchstartY) {
        // console.log("Swiped up");
      }

      if (touchendY > touchstartY) {
        // console.log("Swiped down");
      }

      if (touchendY === touchstartY) {
        // console.log("Tap");
      }
    };

    store.dispatch("movies");

    watch(
      () => store.getters.movies,
      () => {
        slides.value = JSON.parse(JSON.stringify(store.getters.movies));
      }
    );

    return {
      slides,
      handleSlide,
      openCarousel,
      slideMobile,
      touchStart,
      touchEnd,
      data: computed(() => store.getters.movies)
    };
  }
};
</script>

<style scoped lang="scss">
.overlay {
  // position: absolute;
  position: absolute;
  right: 50px;
  top: calc(var(--header-main-height) + 8%);
  width: 100%;
  height: 100%;
  @media screen and (max-width: 1300px) {
    // transform: scale(0.8);
  }

  @media screen and (max-width: 992px) {
    transform: scale(1);

    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: rgba(18, 18, 18, 0.65);
    z-index: 999;
    transition: all 0.5s ease-in-out;
    &::after {
      position: absolute;
      top: 0;
      content: "";
      width: 100%;
      z-index: 2;
    }
  }
}

.control-button {
  display: none;
  @media screen and (max-width: 992px) {
    display: block;
  }
  position: absolute;
  top: 50%;
  left: 65px;
  z-index: 100;
  .button-right {
    position: absolute;
    z-index: 11;
    top: 50%;
    left: -65px;
    width: 65px;
    height: 75px;
    background: rgba(18, 18, 18, 0.25);
    border: 1px solid #ffffff;
    box-sizing: border-box;
    backdrop-filter: blur(4px);
    color: #fff;
    font-size: 2rem;
    border-radius: 4px 0px 0px 4px;
    z-index: 90;
    cursor: pointer;

    @media screen and (max-width: 767px) {
      width: 40px;

      height: 54px;
    }
  }
  .button-left {
    position: absolute;
    top: 50%;
    left: calc(-65px * 2);
    width: 65px;
    height: 75px;
    background: rgba(18, 18, 18, 0.25);
    border: 1px solid #ffffff;
    box-sizing: border-box;
    backdrop-filter: blur(4px);
    color: #fff;
    font-size: 2rem;
    border-radius: 4px 0px 0px 4px;
    cursor: pointer;

    @media screen and (max-width: 767px) {
      width: 40px;

      height: 54px;
      left: calc(-50px * 2);
    }
  }
}
.paginate {
  position: relative;
  height: 50px;
  z-index: 10;
  display: grid;
  grid-template-columns: 1fr 1fr;
  div {
    grid-column: 2;
    place-self: center;
    display: flex;
    flex-direction: row-reverse;
    @media screen and (max-width: 992px) {
      grid-column: 1 / span 2;
    }
  }
  span {
    cursor: pointer;
    display: inline-block;
    margin: 0 0.5rem;
    background: rgba(255, 255, 255, 0.5);
    border-radius: 13px;
    width: 0.7vw;
    height: 0.7vw;
    border-radius: 50%;
    transition: all 0.4s;
    @media screen and (max-width: 992px) {
      background: rgba(255, 255, 255, 1);
      width: 20px;
      height: 20px;
    }
  }
  @media screen and (max-width: 992px) {
    // display:;
    position: absolute;
    bottom: 5%;
    left: 50%;
    transform: translateX(-50%);
  }
  .active-slide {
    width: 1.4vw;
    border-radius: 40%;
    @media screen and (max-width: 992px) {
      width: 40px;
    }
  }
}
img {
  width: 100%;
  height: 100%;
}
.title {
  font-family: Open Sans;
  font-size: 1.3vw;
  font-weight: 600;
  // line-height: 41px;
  color: #ffffff;
  // text-align: right;
  margin-bottom: 10%;
  @media screen and (max-width: 992px) {
    font-style: normal;
    font-weight: normal;
    font-size: 32px;
    line-height: 44px;
    margin-bottom: 0;
  }
  @media screen and (max-width: 767px) {
    font-family: Open Sans;
    font-style: normal;
    font-weight: normal;
    font-size: 22px;
    line-height: 25px;
    margin-bottom: 0.5rem;
  }
}
.genres {
  display: none;
  font-family: Open Sans;
  font-size: 1.7vw;
  font-style: normal;
  font-weight: normal;
  line-height: 2.5vw;
  margin-bottom: 2rem;
  @media screen and (max-width: 992px) {
    display: block;
  }
  @media screen and (max-width: 767px) {
    font-size: 11px;
    margin-bottom: 1rem;
  }
}
.country,
.rating,
.time {
  font-family: Open Sans;
  font-style: normal;
  font-weight: normal;
  // font-size: 20px;
  font-size: 1vw;
  line-height: 1.5vw;
  // text-align: right;
  color: #ffffff;
  margin-bottom: 1rem;
  @media screen and (max-width: 992px) {
    font-style: normal;
    font-weight: normal;
    font-size: 25px;
    line-height: 34px;
  }
  @media screen and (max-width: 767px) {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 19px;
    margin-bottom: 0.5rem;
  }
}
.carousel-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  @media screen and (max-width: 992px) {
    max-width: calc(100% - 65px);
    margin-left: auto;
    position: absolute;
    top: 50%;
    right: 0%;
    transform: translateY(-50%);
    // width: 80%;
    height: 625px;
    z-index: 3;
  }
  @media screen and (max-width: 767px) {
    max-width: calc(100% - 40px);

    height: 70%;
    // width: 80%;
  }
}
.carousel-item {
  position: absolute;
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  z-index: 9;
  transform: scale(1);
  transition: all 0.4s;
  opacity: 0;
  overflow: hidden;
  @media screen and (max-width: 768px) {
    grid-template-rows: repeat(6, 1fr);
  }
  &.primary {
    opacity: 0;
    transform: scale(0.5);
  }

  &.secondary {
    transform: scale(1);
    opacity: 1;

    .description {
      // transform: translateX(-100%);
    }

    .image {
      // transform: translateX(100%);
    }
  }

  &.tret {
    transform: scale(1);
    opacity: 0;
    .description {
      transform: translateX(-100%);
      @media screen and (max-width: 767px) {
        transform: translateX(100%);
      }
    }

    .image {
      transform: translateX(100%);
    }
  }

  .description {
    // background-color: khaki;
    width: 100%;
    height: 100%;
    transition: all 0.4s;
    padding: 0 1rem;
    text-align: right;
    @media screen and (max-width: 992px) {
      display: flex;
      flex-direction: column;
      justify-content: center;
      background: rgba(18, 18, 18, 0.35);
      backdrop-filter: blur(9px);
      text-align: center;
    }
    @media screen and (max-width: 767px) {
      grid-column: span 2;
      grid-row: 5 / span 2;
    }
  }

  .image {
    // background-color: lavender;
    width: 100%;
    height: 100%;
    transition: all 0.4s;
    // padding: 0 1rem;
    @media screen and (max-width: 992px) {
      padding: 0;
    }
    @media screen and (max-width: 767px) {
      grid-column: span 2;
      grid-row: 1 / span 4;
    }
  }
}
</style>
